import React from "react";
import { Box, Stack, Skeleton } from "@mui/material";

const ServiceCardSkeleton = () => {
  return (
    <Box
      position="relative"
      sx={{
        overflow: "hidden",
      }}
    >
      <Box
        height={400}
        borderRadius={2}
        overflow={"hidden"}
        border={"1px solid #c9c7c7"}
        boxShadow={
          "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px"
        }
      >
        <Skeleton
          variant="rectangular"
          height="100%"
          width="100%"
          sx={{ borderRadius: "8px" }}
        />
      </Box>

      <Stack textAlign="center" mt={2.5} mb={1}>
        <Skeleton
          variant="text"
          width="60%"
          height={28}
          sx={{ margin: "0 auto", borderRadius: "4px" }}
        />
        <Skeleton
          variant="text"
          width="40%"
          height={22}
          sx={{ margin: "0 auto", borderRadius: "4px" }}
        />
      </Stack>
    </Box>
  );
};

export default ServiceCardSkeleton;
